( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.content-accordion__accordion:first-of-type button' ).trigger( 'click' );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'content-accordion', COMPONENT );
} )( app );
